export default __webpack_public_path__ + "static/media/Gloves of the Blood God.e30ba343.jpg";